<template>
    <section :class="embedded ? '' : 'rounded-2xl bg-raised shadow-sm'" aria-busy="true" data-testid="event-v2-session-picker-loading">
        <SessionPickerHeaderV2 :age-restriction-label="ageRestrictionLabel" />
        <div class="grid gap-4 p-4" :class="embedded ? 'border-b border-subtle' : ''" aria-hidden="true">
            <div class="grid gap-3">
                <div class="h-8 w-40 rounded-md bg-subtle animate-pulse-subtle"></div>
                <div class="grid gap-1 pr-1">
                    <div class="grid grid-cols-7 gap-1">
                        <span v-for="weekday in weekdays" :key="weekday" class="text-center text-[10px] font-semibold uppercase tracking-wide text-subtle">{{ weekday }}</span>
                    </div>
                    <div class="grid grid-cols-7 gap-1">
                        <div v-for="day in 7" :key="day" class="h-14 rounded-lg bg-subtle animate-pulse-subtle"></div>
                    </div>
                </div>
            </div>
            <div class="grid gap-3">
                <div class="h-5 w-32 rounded-md bg-subtle animate-pulse-subtle"></div>
                <div class="flex gap-2 overflow-hidden">
                    <div v-for="time in 3" :key="time" class="h-9.5 w-28 shrink-0 rounded-lg bg-subtle animate-pulse-subtle"></div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import SessionPickerHeaderV2 from "./SessionPickerHeaderV2.vue";
import {WEEKDAYS} from "./sessionPicker";

export default {
    name: "EventV2SessionPickerSkeleton",
    components: {SessionPickerHeaderV2},
    props: {
        ageRestrictionLabel: {type: String, default: ""},
        embedded: {type: Boolean, default: false},
    },
    data() {
        return {weekdays: WEEKDAYS};
    },
};
</script>
